import { render, staticRenderFns } from "./backbutton.vue?vue&type=template&id=24a7635f&"
import script from "./backbutton.vue?vue&type=script&lang=js&"
export * from "./backbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports